export const imageMimeTypes =
  'image/png, image/jpeg, image/gif, image/bmp, image/svg+xml, image/webp, image/vnd.microsoft.icon,';
